"use client";
import { useTranslations } from "next-intl";
import React from "react";

function GoUp() {
  const handleClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  const t = useTranslations("layout");
  return (
    <div
      onClick={handleClick}
      className="cursor-pointer flex items-center lg:flex-col gap-4  flex-row-reverse justify-center text-white "
    >
      <div className="bg-white rounded-full flex items-center justify-center lg:w-[4.3rem] lg:h-[4.3rem] w-[48px] h-[48px] ">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25.109"
          height="18.377"
          className="max-md:w-[12px]"
          viewBox="0 0 15.109 8.377"
        >
          <path
            id="Path_49625"
            data-name="Path 49625"
            d="M-14235-22930l5.834,5.359,5.742-5.359"
            transform="translate(-14221.657 -22923.391) rotate(180)"
            fill="none"
            stroke="#220859"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2.5"
          />
        </svg>
      </div>
      <div className="lg:text-[1.5rem] text-[12px]">{t("goUp")}</div>
    </div>
  );
}

export default GoUp;
